import classNames from "classnames";
import { NumberInput } from "../../../components/numberInput/numberInput";
import { Input } from "../../../components/input/input";
import { UploadFile } from "../../../components/uploadFile/uplodeFile";

import styles from "./addCategory.module.css";

import { Text } from "../../../components/text/text";

export const InputBlock = ({ type, title, value, setValue, className, min, max, error, editor, ...props }) => {
    return (
        <div className={classNames(styles.input_block, className)}>
            <Text as="div" variant="caption" className={styles.input_block_title} size={14}>
                {title}
            </Text>
            {type === "number" && <NumberInput error={error} val={value} setVal={setValue} min={min} max={max} {...props}/>}
            {type === "textEditor" && editor}
            {type === "file" && <UploadFile selectedFile={value} setSelectedFile={setValue} {...props} />}
            {type !== "number" && type !== "textEditor" && type !== "file" && <Input error={error} type={type} value={value} setValue={setValue} {...props} />}
        </div>
    )
}
